module.exports = __webpack_public_path__ + "src/app/auth/loginPage/linkedin-logo.png?2476255381d3eb69cca82d3b681023ed";